import { ActionIcon, Group, Loader, LoadingOverlay, NumberInput, Paper, SegmentedControl, Space, Stack, Textarea, Tooltip } from '@mantine/core';
import { InputWrapper } from '@mantine/core/./cjs/Input/InputWrapper/InputWrapper.js'
import 'keen-slider/keen-slider.min.css';
import '../ratpack-ui/src/app/AppImports';
import bgImg from '../ratpack-ui/src/assets/images/background-road.jpg';
// import { Box } from '../ratpack-ui/src/components/Box/Box';
import { Button } from '../ratpack-ui/src/components/Button/Button';
import { Checkbox } from '../ratpack-ui/src/components/Checkbox/Checkbox';
import { DatePicker } from '../ratpack-ui/src/components/DatePicker/DatePicker';
// import { ExpandCollapse } from '../ratpack-ui/src/components/ExpandCollapse/ExpandCollapse';
import { Select } from '../ratpack-ui/src/components/Select/Select';
import { TextInput } from '../ratpack-ui/src/components/TextInput/TextInput';
import { AdminCreateQuotePage } from '../ratpack-ui/src/pages/AdminCreateQuotePage';
import { AdminPageLayout } from '../ratpack-ui/src/pages/AdminPageLayout';
import '../ratpack-ui/src/styles/Font.css';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { GET, POST } from '../api';
import { MustLogIn } from '../session';
import { AU_States, LocationKey, NZ_States, Spaced_States, ZDLocationCanonical, before, selected, stateful, toSelectItems, zdid } from '../util';
import { adminDefaults } from './components';
import { AllCountries, AllOperators, HR, InsurancePolicyOption, License_Origin, Operator, OperatorKey, PaymentProfile, PaymentType, ProviderOptions, res_error, res_finalise_quote, RPLocation,
    All_States, DAY, OperatorsGeneric, optionList, typeList,
    // toSlug, // TODO
} from '../../../src/types' /// SHARED

import { Text } from '../ratpack-ui/src/components/Text/Text';
import { useNavigate } from 'react-router-dom';
import { selectorFamily, useRecoilRefresher_UNSTABLE, useRecoilValue } from 'recoil';
import { AsIfParsedFromTimezone } from '../time';
import { Anchor } from '../ratpack-ui/src/components/Anchor/Anchor';
import { useMultiStateBool } from './createQuote';
import { Box } from '../ratpack-ui/src/components/Box/Box';
export type res_finalise = {
    ticket: {
        name: any,
        reference: any,
        pickup: any,
        start: any,
        dropoff: any,
        end: any,
        pax: any,
        children: any,
        operator: string,
        vehicle: string,
        licenseOrigin: License_Origin,
    },
    // quote: res_quote,
}
export const finaliseAtom = selectorFamily<res_finalise, string>({
    key: 'finalise',
    get: zid => ({ get }) => GET(`/api/finalise/${zdid(zid)}`)
})

// Return or display the equivalent discount amount in the opposite format
function convertDiscountDisplay(discountType: 'amount' | 'percent', totalDiscount: number, totalDailyRate: number) {
    const alt = convertDiscount(discountType, totalDiscount, totalDailyRate)
    if (isNaN(alt)) return ''
    const n = (discountType == 'percent') ? `$${alt.toFixed(2)}` : `${alt.toFixed(1)}%`
    return ` (about ${n})`
}
function convertDiscount(discountType: 'amount' | 'percent', totalDiscount: number, totalDailyRate: number, invert: Boolean = false) {
    return (invert != (discountType == 'percent')) ? (totalDiscount / 100) : (100 * totalDiscount / totalDailyRate)
}
const clampDate = (after:Date|number, date:Date|number, before:Date|number) => {
    if(typeof after == 'object') after = after.getTime()
    if(typeof date == 'object') date = date.getTime()
    if(typeof before == 'object') before = before.getTime()
    return new Date(Math.min(Math.max(after,date),before))
}
const allLicenseOrigins = [...AllCountries]
// .sort((a,b) => {
//     // if(['AU','GB','NZ','DE'].includes(a.code))
//     return a.code.localeCompare(b.code)
// })
.map(o => ({label:o.name,value:o.code}))

const MIN_DAYS = 70.4 // 35
const MAX_DAYS = 90.4
const DEFAULT_DAYS = 90.4

export type OperatorKey2 = keyof typeof AllOperators | 'generic'
function ApplyConditionalPaymentProfileMods(pp:PaymentProfile|null, operator: OperatorKey2, pickup:LocationKey):PaymentProfile|null {
    if(!pp) return null
    if(operator=='letsgo') {
        return Object.assign({}, pp, {
            dailyCommission: (({
                "au.melbourne": 0.25,
                "au.sydney": 0.25,
                "au.brisbane": 0.25,
                "au.perth": 0.25,
                "au.adelaide": 0.25,
                "au.darwin": 0.25,
                "au.hobart": 0.20,
                "au.cairns": 0.20,
                "au.broome": 0.075,
            } as Record<LocationKey, number>)[pickup]) ?? pp.dailyCommission,
        } as PaymentProfile)
    }
    return pp
}

const getValidatedRate = async (operator:'cheapa',name:string,pickup_date:Date,dropoff_date:Date,from:string,to:string) => {
    const YMD = (d:Date) => [d.getFullYear(), d.getMonth() + 1, d.getDate()];
    const loc = (l:string) => ({
        "au.sydney": 'syd',
        "au.alice_springs": 'asp',
        "au.darwin": 'drw',
        "au.brisbane": 'bne',
        "au.cairns": 'cns',
        // adelaide: 'adl',
        "au.hobart": 'hbt',
        "au.melbourne": 'mel',
        "au.broome": 'bme',
        "au.perth": 'per',
    } as Record<RPLocation,string>)[l] ?? l
    try {
        return JSON.parse(await fetch("http://staging.ratpacktravel.com:9999/img", {
            "headers": {
                "Content-Type": "application/json",
            },
            "body": JSON.stringify({operator,name,pickup:(pickup_date),dropoff:(dropoff_date),from:loc(from),to:loc(to)}),
            "method": "POST",
        }).then(async r => r.headers.get('X-Metadata')))?.daily ?? 0
    } catch (e) {
        console.error(`Could not validate rates for ${name}`)
        return 0
    }
}

export const FinalisePage = () => {
    const { zid } = useParams()
    const [q2, setQ2] = React.useState<res_finalise_quote | null>(null)
    const { ticket = ({
        children: 0,
        dropoff: '',
        end: '',
        name: '',
        operator: '',
        pax: 0,
        pickup: '',
        reference: '',
        start: '',
        vehicle: '',
    } as res_finalise['ticket']), ...rest } = useRecoilValue(finaliseAtom(zid)) ?? {}
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        const { error } = (rest ?? {} as any)
        setError(error)
    }, [(rest as any).error])

    // <i>FullName, ref, PULocation, DOLocation, PUDate, DODate, NAdults, NChildren, OperatorCompany, VehicleStyle</i>
    // TODO: NAdults, NChildren ?

    const setter = (v: any) => v
    const [name, useName, validName, setName] = stateful(ticket.name)
    const [ref, useRef, validRef, setRef] = stateful(zid)//ticket.reference)
    const [pax, usePax, validPax, setPax] = stateful(parseInt(ticket.pax).toString(), { setter })
    const [childrenPax, useChildrenPax, validChildrenPax, setChildrenPax] = stateful(parseInt(ticket.children).toString(), { setter })

    const [closeOnDone, setCloseOnDone] = React.useState(true)
    const [artifact, setArtifact] = React.useState('')

    const validDateOrToday = (d:Date) => isNaN(d.getTime()) ? new Date() : d
    const [pickup_date, usePickupDate, validPickupDate, setPickupDate] = stateful<Date>(validDateOrToday(new Date(ticket.start)), { setter:validDateOrToday }) // , next: dropOffRef.click()
    // const ifElse = function<T>(condition:Boolean, ifTrue:T, ifFalse:T):T {
    //     return condition ? ifTrue : ifFalse
    // }
    const defaultPaymentDate = () => {
        const nextWorkingDay = (from:Date|number = Date.now()):Date => {
            if(typeof from == 'object') from = from.getTime();
            return Array(4).fill(1).map((v,i)=>new Date(from+(v+i)*DAY)).find(d=>d.getDay()>0 && d.getDay()<6)
        }
        if(Date.now()+(DEFAULT_DAYS*DAY) > pickup_date?.getTime()) return nextWorkingDay()
        return clampDate(
            Date.now()-(1*DAY), // Can be due today
            pickup_date?.getTime()-(MAX_DAYS*DAY),
            pickup_date?.getTime()-(MIN_DAYS*DAY) // Up to pickup-MIN_DAYSd
        )
    }
    const [paymentDate, usePaymentDate, validPaymentDate, setPaymentDate] = stateful<Date>(defaultPaymentDate(), { setter }) // When the remaining balance is due
    const resetPaymentDate = () => setPaymentDate(defaultPaymentDate())

    const [dropoff_date, useDropoffDate, validDropoffDate, setDropoffDate] = stateful<Date>(validDateOrToday(new Date(ticket.end)), { setter:validDateOrToday })

    const [license_origin, useLicenseOrigin, validLicenseOrigin, setLicenseOrigin] = stateful<License_Origin>(ticket.licenseOrigin ?? 'AU', { setter })
    const [pickup, usePickup, validPickup, setPickup] = stateful<LocationKey>(ZDLocationCanonical(ticket.pickup), { setter })
    const [dropoff, useDropoff, validDropoff, setDropoff] = stateful<LocationKey>(ZDLocationCanonical(ticket.dropoff), { setter })

    const country:'au'|'nz' = (pickup.split('.')[0] as 'au'|'nz') ?? 'au'

    const [operator, useOperator, validOperator, setOperator] = stateful(ticket.operator as OperatorKey2, {
        setter,
        validate: v => [
            ...Object.keys(AllOperators),
            'generic',
        ].includes(v),
    })
    const [types, useType, renderTypes, setTypes] = useMultiStateBool(typeList.map(item => item.nice))

    const days = (pickup_date && dropoff_date) ? 1 + Math.round((dropoff_date.getTime() - pickup_date.getTime()) / DAY) : null
    const DropOffDateLabel = `Drop off date ${days !== null ? `( ${days} days )` : ''}`

    const [discountType, useDiscountType, validDiscountType, setDiscountType] = stateful<"percent" | "amount">('amount', {
        setter, effect: discountType => {
            // setDiscount(convertDiscount(discountType, totalDiscount, totalDailyRate, true)); // Requested disabled
        }
    })
    const [discountAmount, useDiscount, validDiscount, setDiscount] = stateful<number>(0, { setter })

    const localCurrency = (country=='au')?'AUD':'NZD'
    const [showCurrency, useShowCurrency, validShowCurrency, setShowCurrency] = stateful<currency>(localCurrency, {setter})
    const [currencyRate, setCurrencyRate] = React.useState<number|null>(0);

    // React.useEffect(()=>{ setDiscount(convertDiscount(discountType, totalDiscount, totalDailyRate, true)); }, [discountType])
    React.useEffect(() => { if (isNaN(discountAmount)) setDiscount(0); }, [discountAmount])

    const [rate, useRate, validRate, setRate] = stateful<number>(0, { setter })
    const [insuranceRate, useInsuranceRate, validInsuranceRate, setInsuranceRate] = stateful<number>(0, { setter })
    const [insuranceBond, useInsuranceBond, validInsuranceBond, setInsuranceBond] = stateful<number>(0, { setter })
    const [commissionableFee, useCFee, validCFee, setCFee] = stateful<number>(0, { setter })
    const [nonCommissionableFee, useNCFee, validNCFee, setNCFee] = stateful<number>(0, { setter })

    const nName = (name: string) => {
        const [first, ...rest] = name.split(' ')
        return [first, rest.join(' ')]
    }

    const getVehicle = (vehicle: string) => q2?.quote?.offers?.find(({ id }) => id == vehicle)
    const getPolicy = (vehicle: string, policy: string | null):InsurancePolicyOption => {
        const policies = (getVehicle(vehicle)?.policies ?? []) as InsurancePolicyOption[]
        if (policy === null) {
            const sorted = policies.filter(p=>p.fees).sort((b, a) => parseInt(a.fees as any) - parseInt(b.fees as any))
            const highest = sorted?.[0]
            console.log({policies, sorted, highest})
            return highest
        }
        return policies.find(({ id }) => id == policy)
    }
    const [vehicle, useVehicle, validVehicle, setVehicle] = stateful(ticket.vehicle, {
        setter, effect: vehicle => { // TODO: make effect: more like useEffect? effect is nice because it doesn't need to re-render N times if all the state is in scope
            // NOTE: use useEffect, otherwise the setter will not be able to see the updated vehicle
            // setRate((getVehicle(vehicle)?.daily ?? 0) /100)
            // const Policy = getPolicy(vehicle,null)
            // setPolicy(getPolicy(vehicle,null)?.id?.toString()??'none')
        }
    })//, validate: v => q2?.offers?.map(({id})=>id).includes(v) }) // TODO: support validator updating on same re-render as setting the value? seems to cause issues
    const Vehicle = getVehicle(vehicle)
    const [validatedRates,setValidatedRates] = React.useState({})
    React.useEffect(() => {
        const V = getVehicle(vehicle)
        const rate = (V?.daily ?? 0)
        setRate(rate / 100)
        const Policy = getPolicy(vehicle, null)
        setPolicy(Policy?.id?.toString() ?? 'none')

        const trySetPolicyName = (name:string) => {
            const defaultPolicy = policies.find(p => p.name.includes(name))
            if(defaultPolicy) setPolicy(defaultPolicy?.id?.toString() ?? 'none')
        }
        const policies = (getVehicle(vehicle)?.policies ?? []) as InsurancePolicyOption[]
        if((['jucy','star-rv'] as Array<typeof operator>).includes(operator)) {
            trySetPolicyName('Stress Free Plus')
            // setCFee((V?.fee ?? 0) /100)
            setNCFee((V?.fee ?? 0) /100)
        } else {
            setNCFee((V?.fee ?? 0) /100)
        }
        if((['apollo', 'hippie', 'maui', 'britz', 'mighty', 'cheapa'] as Array<typeof operator>).includes(operator)) {
            trySetPolicyName('Value Pack Partner')
        }
        if((['spaceships'] as Array<typeof operator>).includes(operator)) {
            trySetPolicyName('Stress-Free')
        }
        if((['camperman'] as Array<typeof operator>).includes(operator)) {
            setInsuranceBond(500)
        }
        if((['apollo', 'hippie', 'maui', 'britz', 'mighty', 'cheapa'] as Array<typeof operator>).includes(operator)) {
            if(V?.name && !Object.keys(validatedRates).includes(V?.name))
                getValidatedRate('cheapa',V?.name,pickup_date,dropoff_date,pickup,dropoff).then(rate => setValidatedRates(r => ({...r, [V?.name]:rate})))
        }
    }, [vehicle]); // Dependency array includes product
    const [policy, usePolicy, validPolicy, setPolicy] = stateful('', {
        setter, effect: policy => {
            const Policy = getPolicy(vehicle, policy)
            console.log(`Set policy`, { vehicle, policy, Policy })
            setInsuranceRate((Policy?.fees ?? 0) / 100)
            setInsuranceBond((Policy?.excessamount ?? 0) / 100)
        }
    })
    const Policy = getPolicy(vehicle, policy)
    const sortPolicies = policies => policies.sort((a, b) => a.fee - b.fee)
    const ifNaN = (v = 1, d = null, toFixed=null) => isNaN(v) ? d : (toFixed==null ? v : v.toFixed(toFixed))
    const ifN = (v: number, isN = (v: number) => v.toString(), isNN = (v: typeof NaN) => '?') => isNaN(v) ? isNN(v) : isN(v)

    const [loading, setLoading] = React.useState<boolean>(false)
    const Dropoff_States = pickup.length ? toSelectItems(pickup.startsWith('au.') ? AU_States : NZ_States) : Spaced_States

    // Set up commission rates for the dailyRate,insurance,commissionableExtras components of the order
    const profile = ApplyConditionalPaymentProfileMods(q2?.profiles?.[`${country}.${operator}`] as PaymentProfile|null, operator, pickup) as PaymentProfile|null
    if(profile==null) console.error(`Missing payment profile information for operator`, {pickup,profile,country,operator,keys:Object.keys(q2?.profiles??{})})
    const [commRate, useCommRate, validCommRate, setCommRate] = stateful<number>(25, { setter, effect:value=>{
        if((profile?.insuranceCommission??0)==0) return
        setCommRateInsurance((profile?.insuranceCommission ?? value) * 100)
    } })
    const [commRateInsurance, useCommRateInsurance, validCommRateInsurance, setCommRateInsurance] = stateful<number>(0, { setter })
    // const [commRateExtra, useCommRateExtra, validCommRateExtra, setCommRateExtra] = stateful<number>(0, { setter })
    const resetCommsRate = ()=>{
        setCommRate(profile?.dailyCommission * 100)
        setCommRateInsurance((profile?.insuranceCommission ?? profile?.dailyCommission) * 100)
        // setCommRateExtra((profile?.extraCommission ?? profile?.dailyCommission) * 100)
    }
    React.useEffect(() => {
        resetCommsRate()
    }, [q2?.profiles])

    const [manualNetRate,useManualNetRate,validManualNetRate,setManualNetRate] = stateful<number>(0, { setter })
    const [manualNetMode,useManualNetMode,validManualNetMode,setManualNetMode] = stateful<'calculated'|'override'>('calculated', { setter })

    const {
        internal,
        external,
        deposit, // RPT commission, the required deposit amount
        total, // RPT offer total rate
        totalDiscount, // cents discounted
        totalDirectRate, // total with no discounts
        totalDailyRate, // daily direct rate * days
        commission,
        paymentProfile,
        netRate,  // daily cents, equal to overrideNetRate if it was given, deprecating
        netRateTotal, // total cents, prefer this to netRate to avoid floating point errors
        calculatedNetRate, // daily cents, equal to netRate unless overrideNetRate was given
        calculatedNetRateTotal,
        payoff_amount,
    } = generateMemos({
        localCurrency,
        currencyRate,
        showCurrency,
        dropoff: dropoff,
        originalRate: Vehicle?.daily ?? (rate*100),
        pickup: pickup,
        start: pickup_date,
        end: dropoff_date,
        pax: pax,
        paxChildren: childrenPax,
        zdid: zid,
        camper: Vehicle?.name, // TODO: map to format?
        company: operator, //AllOperators[operator], // TODO: map to format?
        bond: insuranceBond * 100,
        insurance: insuranceRate * 100,
        originalInsuranceRate: Policy?.fees ?? (insuranceRate * 100),
        commissionableExtras: commissionableFee * 100,
        nonCommissionableExtras: nonCommissionableFee * 100,
        dailyRate: rate * 100,
        days,
        // discountAmount: totalDiscount,
        discountType,
        discountAmount,
        link: Vehicle?.specs,
        pickupDate: pickup_date,
        commRateForCompany: commRate / 100,
        commRateForCompanyInsurance: commRateInsurance / 100,
        country,
        overrideNetRate: (Vehicle?.override_net ?? null),
        manualNetRate: (manualNetMode=='override' ? manualNetRate*100/days : null),
        daily_for_net: Vehicle?.daily_for_net,
        insurancePolicyName: Policy?.name,
        insuranceMax: Policy?.maximumprice*100,
        insuranceMin: Policy?.minimumprice*100,
        paymentDate, 
        paymentProfile: profile,
    })

    React.useEffect(() => { // TODO: debounce?
        setLoading(true);
        setCurrencyRate(null);
        if (isNaN(discountAmount))  return
        getCurrencyRate(showCurrency,localCurrency).then(n => setCurrencyRate(n)).finally(()=>setLoading(false))    
    }, [showCurrency])

    React.useEffect(()=>{
        // NOTE: manualNetRate is total dollars, but calculatedNetRate, netRate, overrideNetRate are daily cents
        console.log({manualNet: manualNetMode,manualNetRate})
        // if(manualNetMode=='override') 
        setManualNetRate(((calculatedNetRateTotal))/100)
    }, [manualNetMode])

    const discountedTotal = total - totalDiscount

    const setEventTargetValue = (e: InputEvent) => (e.target as HTMLInputElement).value
    const setDisabled = (e: InputEvent) => (v:any) => v
    const internalMemoLocked = true
    const [internalMemo, useInternalMemo, validInternalMemo, setInternalMemo] = stateful<string>(internal, { setter: internalMemoLocked ? setDisabled : setEventTargetValue })
    const [externalMemo, useExternalMemo, validExternalMemo, setExternalMemo] = stateful<string>(external, { setter: setEventTargetValue })
    React.useEffect(() => {
        setInternalMemo(internal)
        setExternalMemo(external)
    }, [internal, external]);
    const internalMemoChanged = internalMemo != internal
    const externalMemoChanged = externalMemo != external

    const RESET = () => {
        resetPaymentDate()
        setQ2(null)
        setCFee(0)
        setNCFee(0)
        setDiscount(0)
        setDiscountType('amount')
        resetCommsRate()
        setShowCurrency(localCurrency)
        setVehicle(ticket.vehicle)
        setManualNetMode('calculated')
    }
    console.log({ discountType, total, totalDiscount, discountedTotal, pickup_date, dropoff_date, pickup, dropoff, operator, types, Vehicle, Policy, commission, deposit })
    const showLicenseOrigin = true // isTHL
    return (<AdminPageLayout {...adminDefaults({ page: 'finalise' })} page={<>
        <MustLogIn />

        {!q2 ? (<AdminCreateQuotePage
            backgroundImage={bgImg}
            topSpace={<Space h={50} />}
            topBox={AdminCreateQuotePage.TopBox({
                firstNameInput: <TextInput {...useName} placeholder="First Name" label="Customer Name" />,
                lastNameInput: [], // <TextInput {...useSurname} placeholder="Last Name" />,
                bookingRefInput: <TextInput {...useRef} disabled placeholder="#12345" label="Ticket Number" />, // RPT Booking Ref"
                tripNameInput: [], // <TextInput {...useTitle} placeholder="Description" label="Trip Name" />,
                topRightInput: showLicenseOrigin ? <Select
                    label="License Origin"
                    // onMouseDown={e => setLicenseOrigin('')}
                    placeholder="Select"
                    {...useLicenseOrigin}
                    onMouseDown={e => setLicenseOrigin('')}
                    data={allLicenseOrigins}
                ></Select> : [], // <TextInput {...useTitle} placeholder="Description" label="Trip Name" />,
            })}
            middleSpace={<Space h={20} />}
            bottomBox={AdminCreateQuotePage.BottomBox({
                pickUpLocationSelect: (<Group dir='column'>
                    <Select
                        label="Pick up location"
                        onMouseDown={e => setPickup('')}
                        placeholder="Select"
                        {...usePickup}
                        onChange={v => {
                            setPickup(v)
                            setDropoff(v)
                        }}
                        data={Spaced_States}
                    ></Select>
                    <Select
                        label="Drop off location"
                        onMouseDown={e => setDropoff('')}
                        placeholder="Select"
                        {...useDropoff}
                        data={Dropoff_States ?? []}
                    ></Select>
                </Group>
                ),
                dropOffLocationSelect: [],
                // pickUpDatePicker: <DatePicker
                //     {...useDates}
                //     type="range"
                //     placeholder="Select"
                //     label="Dates"
                //     excludeDate={d => before()(AsIfParsedFromTimezone(d))}
                //     onChange={d => {
                //         setDates(d)
                //         // if (!dropoff_date || (dropoff_date.getTime() < d.getTime())) setDropoffDate(d)
                //     }}
                // />,
                pickUpDatePicker: <Group dir='column'>
                    <DatePicker
                        {...usePickupDate}
                        placeholder="Select"
                        label="Pick up date"
                        excludeDate={d => before()(AsIfParsedFromTimezone(d))}
                        onChange={d => {
                            setPickupDate(d);
                            (document.querySelector('input#dropoff_date') as HTMLElement)?.click()
                            if (!dropoff_date || ((dropoff_date as any).getTime() < d.getTime())) setDropoffDate(d)
                        }}
                    />
                    <DatePicker
                        {...useDropoffDate}
                        id="dropoff_date"
                        placeholder="Select"
                        label={DropOffDateLabel}
                        excludeDate={d => before(pickup_date as any ?? new Date())(AsIfParsedFromTimezone(d))}
                    />
                </Group>,
                dropOffDatePicker: [],
                numberOfPeopleSelect: (<Group dir='column'>
                    <Select
                        searchable={false}
                        label="Number of people"
                        placeholder="Select"
                        {...usePax}
                        data={[1, 2, 3, 4, 5, 6, 7, 8].map(n => {
                            return { value: `${n}`, label: n == 1 ? `1 Person` : `${n} People` }
                        })}
                    ></Select>
                    <Select
                        searchable={false}
                        label="Number of children"
                        placeholder="Select"
                        {...useChildrenPax}
                        data={[0, 1, 2, 3, 4, 5, 6, 7, 8].map(n => {
                            return { value: `${n}`, label: n == 1 ? `1 Child` : `${n} Children` }
                        })}
                    ></Select>
                </Group>),
                filtersExpandCollapse: <Text>Filters</Text>, // <ExpandCollapse label="Filters" />,
                filtersArea: AdminCreateQuotePage.FiltersArea({
                    discountSelect: [],
                    offerEndsSelect: [],
                    operatorsCheckboxGroup: (
                        <Select
                            searchable={true}
                            onMouseDown={e => setOperator('')}
                            {...useOperator}
                            label="Operator"
                            placeholder="Operator"
                            data={[
                                ...Object.entries(AllOperators).map(([value, label]) => ({ value, label })),
                                {value: 'generic', label:'Generic'},
                            ]}
                        ></Select>
                    ),
                    specOptionsCheckboxGroup: [],
                    camperTypeCheckboxGroup: (false &&
                        <InputWrapper label={
                            <Group dir="row">
                                Camper Type
                                <Tooltip label="Select none to search everything" style={{ display: 'inline' }}>
                                    <p style={{ fontSize: '10px', paddingLeft: '5px' }}>?</p>
                                </Tooltip>
                            </Group>
                        }>
                            {renderTypes(({ value, ...rest }) => <Checkbox checked={value ?? false} {...rest} />)}
                        </InputWrapper>
                    ),
                }),
            })}
            searchArea={
                AdminCreateQuotePage.SearchArea({
                    searchButton:
                        <Group style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <Group dir="row" style={{ width: '100%', justifyContent: 'space-between' }}>
                                <Text> </Text>
                                <Group style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <Button
                                        disabled={loading}
                                        onClick={() => {
                                            const quoteRequest = ({
                                                // Inherit
                                                title: `Finalisation for ${ticket.reference}`,
                                                offer_duration: '24',
                                                pax: pax,
                                                // Inputs
                                                'prepared_for': name,
                                                'discount_percent': '0',
                                                'name': nName(name)[0],
                                                'surname': nName(name)[1],
                                                'reference': ref,
                                                pickup,
                                                dropoff,
                                                pickup_date,
                                                dropoff_date,
                                                // pickup_date: new Date(pickup_date.getTime()+(8*HR)),
                                                // dropoff_date: new Date(dropoff_date.getTime()+(8*HR)),
                                                license_origin,
                                                // Filters
                                                'operators': [operator],
                                                'options': [],
                                                types: selected(types),
                                                // Settings
                                                'mode': 'sync', // Allow empty results, return asynchronously
                                                insurance: true,
                                            })
                                            setLoading(true)
                                            setError(null)
                                            console.log({ quoteRequest })
                                            setVehicle(null)
                                            resetPaymentDate()
                                            const isErr = (res:any):res is res_error => res?.error || res?.status == "Bad Request"
                                            const gotQuote = (res:res_finalise_quote) => {
                                                setQ2(res)
                                                try {
                                                    const vehs = res?.quote?.offers ?? []
                                                    const veh = vehs.find(veh => veh?.id == vehicle) ?? vehs[0] ?? null
                                                    console.log({ veh })
                                                    setVehicle(veh?.id?.toString())
                                                } catch (e) {
                                                    console.error(e)
                                                    setError(`Data error: ${e}`)
                                                }
                                            }
                                            if(operator=='generic') {
                                                gotQuote({
                                                    profiles: {[`${country}.generic`]:{
                                                        dailyCommission: 0,
                                                        mode: 'GROSS_DOWN',
                                                        type: 'DEPOSIT', // 'FULL_PAYMENT',
                                                        // extraCommission: 0,
                                                        insuranceCommission: 0,
                                                    }},
                                                    quote: {
                                                        offers: [{
                                                            policies: [],
                                                            amenity: 'NoToiletShower',
                                                            bed: 'generic',
                                                            boosterSeats: 0,
                                                            daily: 0,
                                                            discount_total: 0,
                                                            fee: 0,
                                                            fridge: 'generic',
                                                            id: 0,
                                                            imagesLink: 'generic',
                                                            internalDataLink: 'generic',
                                                            name:'Generic',
                                                            newness:'',
                                                            pax: 0,
                                                            provider_key: 'generic',
                                                            rp_id: 'generic',
                                                            specs: null,
                                                            total: 0,
                                                            transmission: 'Automatic',
                                                            type: '',
                                                            youtubeLink: '',
                                                        }],
                                                        dropoff: dropoff,
                                                        pickup: pickup,
                                                    } as any
                                                })
                                                setLoading(false)
                                                return
                                            }
                                            POST(`/api/finalise/${zdid(zid)}`, quoteRequest)
                                                .then((res:res_finalise_quote|res_error) => {
                                                    setArtifact((res as any)?.artifact??'')
                                                    if (isErr(res)) return setError(res.error ?? res.message)
                                                    gotQuote(res)
                                                })
                                                .catch(e => setError(`API Error: ${e}`))
                                                .finally(() => setLoading(false))
                                            // NOTE: optionally use quoteAtom here
                                        }}
                                    >{loading ? <Loader /> : 'See Rates'}</Button>
                                    {!!error &&
                                        <Group style={{
                                            backgroundColor: 'black',
                                            padding: '10px',
                                            margin: '5px',
                                        }}>
                                            <Text backgroundColor="white" color="red">{error}</Text>
                                        </Group>
                                    }
                                </Group>
                                {/* <Text><Anchor onClick={resetFields} size="sm">Reset All Fields</Anchor></Text> (REFRESH THE PAGE)*/}
                            </Group>
                        </Group>,
                })
            }
        />) : /* STEP 2 */ (<AdminCreateQuotePage
            backgroundImage={bgImg}
            topSpace={<Space h={50} />}
            topBox={

                <Box styleType="translucent">
                    <Group>

                        <Stack style={{ flexGrow: 2 }}>
                            <Group>
                                <Select
                                    label={Vehicle ?
                                        ((validatedRates[Vehicle.name]??0)!=0 ?
                                            `Vehicle ($${((Vehicle.daily ?? 0) / 100)?.toFixed(2)}/d) (${validatedRates[Vehicle.name]==Math.round(Vehicle.daily+(Vehicle.fee/Math.max(days-1,1))) ? 'Matches live rate' : 'Does not match live rate'})` :
                                            `Vehicle ($${((Vehicle.daily ?? 0) / 100)?.toFixed(2)}/d)`) :
                                        "Vehicle"}
                                    styles={{
                                        root: {
                                            maxWidth: '400px',
                                            minWidth: '200px',
                                        }
                                    }}
                                    onMouseDown={e => {
                                        console.log('clearVehicle')
                                        setVehicle('')
                                    }}
                                    placeholder="Select"
                                    itemComponent={SelectItemRedUnavailable}
                                    {...useVehicle}
                                    onChange={v => {
                                        console.log({ setVehicle: v })
                                        setVehicle(v.toString())
                                    }}
                                    data={(q2?.quote?.offers ?? []).map(({ name, id, daily, ...rest }) => ({ label: name??(rest as any)?.option?.Name??id, value: id.toString(), available: !!daily }))}
                                ></Select>
                                <RPNumberInput
                                    style={{ width: '80px' }}
                                    placeholder="0"
                                    label="Rate"
                                    defaultValue={0}
                                    precision={2}
                                    {...useRate}
                                    min={0}
                                    hideControls
                                />
                            </Group>
                            <Group>
                                <Select
                                    label={Policy ? `Insurance ($${((Policy.fees ?? 0) / 100)?.toFixed(2)}/d)` : "Insurance"}
                                    styles={{
                                        root: {
                                            maxWidth: '400px',
                                            minWidth: '200px',
                                        }
                                    }}
                                    onMouseDown={e => {
                                        console.log('clearPolicy')
                                        setPolicy('')
                                    }}
                                    itemComponent={SelectItem}
                                    placeholder="Select"
                                    {...usePolicy}
                                    onChange={v => {
                                        console.log({ setPolicy: v })
                                        setPolicy(v.toString())
                                    }}
                                    data={[
                                        { label: 'None', value: 'none', description: 'No insurance' },
                                        ...sortPolicies(Vehicle?.policies ?? []).map(({ id, name, fees, maximumprice, excessamount, totalinsuranceamount },i) => ({
                                            label: name??id??`Policy ${i}`,
                                            description: [
                                                `$${(fees / 100).toFixed(0)}/d`,
                                                // maximumprice?`${maximumprice}max`:null,
                                                `$${(excessamount / 100).toFixed(0)}bond`,
                                                `=$${(totalinsuranceamount / 100).toFixed(0)}`,
                                                (maximumprice <= totalinsuranceamount) ? '(max)' : null,
                                            ].filter(Boolean).join(', '),
                                            value: id.toString(),
                                        })),
                                    ]}
                                ></Select>
                                <Group>

                                    <RPNumberInput
                                        style={{ width: '80px' }}
                                        placeholder="0"
                                        label={`Rate`}
                                        defaultValue={0}
                                        precision={2}
                                        {...useInsuranceRate}
                                        min={0}
                                        hideControls
                                    />
                                    <RPNumberInput
                                        style={{ width: '80px' }}
                                        placeholder="0"
                                        label={`Bond`}
                                        defaultValue={0}
                                        precision={2}
                                        {...useInsuranceBond}
                                        min={0}
                                        hideControls
                                    />
                                </Group>

                            </Group>
                        </Stack>
                        <Stack style={{ flexGrow: 1, maxWidth: '200px' }}>
                            <RPNumberInput
                                placeholder="0"
                                label={`Commission Rate (${ifNaN(profile?.dailyCommission*100,'?',0)}%)`}
                                defaultValue={0}
                                precision={2}
                                {...useCommRate}
                                min={0}
                                rightSection={"%"}
                                hideControls
                                style={(['apollo', 'cheapa', 'hippie', 'mighty', 'maui', 'britz'] as Array<OperatorKey>).includes(operator) ? {display:'none'} : {}}
                            />
                            { operator == 'generic' && <RPNumberInput
                                placeholder="0"
                                label={`Insurance Commission Rate (${ifNaN(profile?.insuranceCommission*100,'?',0)}%)`}
                                defaultValue={0}
                                precision={2}
                                {...useCommRateInsurance}
                                min={0}
                                rightSection={"%"}
                                hideControls
                            />}
                            {profile?.type=='FULL_PAYMENT' ? '' : <RPNumberInput
                                placeholder="0"
                                label={`Commissionable Fees`}
                                defaultValue={0}
                                precision={2}
                                {...useCFee}
                                min={0}
                                hideControls
                            />}
                            <RPNumberInput
                                placeholder="0"
                                label={`Non-Commissionable Fees`}
                                defaultValue={0}
                                precision={2}
                                {...useNCFee}
                                min={0}
                                hideControls
                            />
                        </Stack>
                    </Group>
                </Box>
            }
            middleSpace={<Space h={20} />}
            bottomBox={AdminCreateQuotePage.BottomBox({
                pickUpLocationSelect: <Stack>
                    <Text size='sm'>Discount Type</Text>
                    <SegmentedControl
                        data={[
                            { label: 'Amount', value: 'amount' },
                            { label: 'Percent', value: 'percent' },
                        ]}
                        {...useDiscountType}
                        label="Discount Type"
                    />
                    {/* <Select
                        label="Discount Type"
                        searchable={false}
                        onMouseDown={e => setDiscountType('')}
                        placeholder="Select"
                        {...useDiscountType}
                        data={[{label:'Percent', value:'percent'}, {label:"Amount", value:"amount"}]}
                    ></Select> */}
                    <RPNumberInput
                        style={{ width: '250px' }}
                        placeholder="0"
                        label={`Discount Amount` + ((discountType == 'percent') ? convertDiscountDisplay(discountType, totalDiscount, totalDailyRate) : '')}
                        defaultValue={0}
                        precision={2}
                        {...useDiscount}
                        icon={(discountType == 'amount') ? "$" : ''}
                        rightSection={(discountType == 'percent') ? "%" : ''}
                        min={0}
                        max={discountType == 'percent' ? 100 : (totalDailyRate / 100)}
                        hideControls
                    />
                    <Space h="lg"></Space>
                    <Text size='sm'>Display Currency</Text>
                    <SegmentedControl
                        data={currencies.map(value => ({label:value,value}))}
                        {...useShowCurrency}
                        label="Display Currency"
                        disabled={loading}
                    />
                    {((paymentProfile as PaymentProfile)?.type == 'FULL_PAYMENT' && ((pickup_date?.getTime() - MIN_DAYS*DAY)>Date.now())) ? <>
                        <Space h="lg"></Space>
                        <DatePicker
                            {...usePaymentDate}
                            placeholder="Select"
                            label={isNaN(pickup_date?.getTime() - paymentDate?.getTime()) ? 'Payment due date' :`Payment due date (${Math.round(daysBetween(pickup_date, paymentDate))} days)`}
                            excludeDate={d => 
                                before(new Date(Date.now()-DAY))(AsIfParsedFromTimezone(d)) || // must be during or after today
                                before(new Date((pickup_date?.getTime()??0) - ((0.5+MAX_DAYS)*DAY)))(AsIfParsedFromTimezone(d)) || // cannot be >MAX_DAYd prior to pickup
                                !before(new Date((pickup_date?.getTime()??0) - (MIN_DAYS*DAY)))(AsIfParsedFromTimezone(d)) // cannot be <MIN_DAYSd prior to pickup
                            }
                        />
                    </> : []}
                </Stack>,
                dropOffLocationSelect: [],
                // pickUpDatePicker:  <Text size='sm'>Total direct rate: ${(total/100)?.toFixed(2)}</Text>,
                // dropOffDatePicker: <Text size='sm'>Total RPT rate: ${(discountedTotal/100)?.toFixed(2)}</Text>,
                // numberOfPeopleSelect: <Text size='sm'>Total commission: {commission}</Text>,
                pickUpDatePicker: [],
                dropOffDatePicker: [],
                numberOfPeopleSelect: <Group dir="col">
                    <Tooltip position="right" offset={20} label="The amount the customer would pay by booking direct (Rate*Days+Extras)" style={{ display: 'inline' }}>
                        <RedNumber label="Total direct rate: " n={totalDirectRate / 100} />
                    </Tooltip>
                    <Tooltip position="right" offset={20} label="The amount the customer will pay by booking via RPT (TDR-Discount)" style={{ display: 'inline' }}>
                        <RedNumber label="Total RPT rate: " n={total / 100} />
                    </Tooltip>
                    <Tooltip position="right" offset={20} label="The amount for RPT once the operator is paid (RPT-NET-Extras)" style={{ display: 'inline' }}>
                        <RedNumber label="Total commission: " n={commission / 100} />
                    </Tooltip>
                    {/* {paymentProfile?.mode === 'NET_UP' ? ( */}
                    {(manualNetMode=='override') ? <>
                        <RPNumberInput
                            style={{ width: '100px' }}
                            placeholder="0"
                            label={`Total NET for ${days} days:`}
                            defaultValue={0}
                            precision={2}
                            {...useManualNetRate}
                            icon={"$"}
                            rightSection={''}
                            hideControls
                            size='xs'
                            parser={(num)=>{
                                const parsedNum = parseFloat(num.replace(/,/gim,''));
                                if (Number.isNaN(parsedNum)) { return undefined; }
                                return parsedNum;
                            }}
                        />
                        <Anchor
                            size='xs'
                            onClick={e=>setManualNetRate(calculatedNetRateTotal/100)}
                        >${ifNaN(calculatedNetRateTotal/100,"?",2)}</Anchor>
                    </> :
                        <Tooltip position="right" offset={20} label="The amount the operator charges for the RPT booking (Excluding Extras(?))" style={{ display: 'inline' }}>
                            <RedNumber label={`Total NET for ${days} days: `} n={ifNaN(netRateTotal/100,"?",2)} rule={v=>true} />
                        </Tooltip>
                    }
                    <SegmentedControl
                        data={[
                            { label: 'Calculated', value: 'calculated' },
                            { label: 'Override', value: 'override' },
                        ]}
                        orientation="vertical"
                        size='xs'
                        style={{
                            paddingRight: 5,
                        }}
                        {...useManualNetMode}
                        label="NET"
                    />
                    {/* ) : '' } */}
                    {/* <RedNumber label="Total commission: " n={deposit / 100} /> */}
                </Group>,
                filtersExpandCollapse: [],
                filtersArea: <Group dir="col">
                    <NotePaper
                        label={externalMemoChanged ? "External Message (modified)" : "External Message"}
                        useValue={useExternalMemo}
                    />
                    <NotePaper
                        // disabled
                        label={internalMemoLocked ? "Internal Note (locked)" : (internalMemoChanged ? "Internal Note (modified)" : "Internal Note")}
                        useValue={useInternalMemo}
                        // useValue={{...useInternalMemo, onChange: (e:any)=>e }}
                    />
                </Group>,
            })}

            searchArea={
                AdminCreateQuotePage.SearchArea({
                    searchButton:
                        <Group style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <Group dir="row" style={{ width: '100%', justifyContent: 'space-between' }}>
                                <Text> </Text>
                                <Group style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <Button
                                        disabled={loading}
                                        onClick={() => {
                                            setLoading(true)
                                            setError(null)
                                            const multiPay = (paymentDate?.getDate()>0) && (profile.type == 'FULL_PAYMENT')
                                            const payoff_date = multiPay ? paymentDate.getTime() : Date.now()+(1*3600e3)
                                            POST(`/api/finalise/${zdid(zid)}/send`, {
                                                internal: internalMemo,
                                                external: externalMemo,
                                                currency: localCurrency,
                                                amount: commission, // commission as it appears below --- in memo, but in cents
                                                vehicle: Vehicle.rp_id, // ZDID for the vehicle
                                                start_date: pickup_date,
                                                end_date: dropoff_date,
                                                pax,
                                                children: childrenPax,
                                                pickup,
                                                dropoff,
                                                remaining_payment_due: payoff_date,
                                                payoff_amount: (paymentProfile.type == 'FULL_PAYMENT' ? (netRateTotal) : commission),
                                                // payoff_amount, // : Math.ceil(multiPay ? payoff_amount : (payoff_amount ?? commission)),

                                                discountAmount,
                                                discountType,
                                                totalDirectRate,
                                                totalDiscount,
                                                netRate, // TODO: deprecate
                                                netRateTotal,
                                                days,
                                                paymentProfile,
                                                insuranceBond,
                                                insuranceRate,
                                                
                                            })
                                                .then(res => {
                                                    console.dir(res)
                                                    if (res.error || res.status == "Bad Request") return setError(res.error ?? res.message)
                                                    if(closeOnDone) return window.close();
                                                    setArtifact(res.artifact) // For API response viewer
                                                    // window.location.href = `https://theratpacktravelteam.zendesk.com/agent/tickets/${zdid(zid)}`
                                                })
                                                .catch(e => setError(e))
                                                .finally(() => setLoading(false))
                                        }}
                                    >{loading ? <Loader /> : 'Finalise & Save Quote'}</Button>
                                    <Button
                                        disabled={loading}
                                        onClick={RESET}
                                    >{loading ? <Loader /> : 'Search Again'}</Button>
                                    {!!artifact && !closeOnDone &&
                                        <Group style={{
                                            backgroundColor: 'black',
                                            padding: '10px',
                                            margin: '5px',
                                        }}>
                                            <Anchor href={`/api/artifact/`+artifact} target="_blank"><Text backgroundColor="white" color="green">Artifact:{artifact}</Text></Anchor>
                                        </Group>
                                    }
                                    {!!error &&
                                        <Group style={{
                                            backgroundColor: 'black',
                                            padding: '10px',
                                            margin: '5px',
                                        }}>
                                            <Text backgroundColor="white" color="red">{error}</Text>
                                        </Group>
                                    }
                                    <Checkbox checked={closeOnDone} onChange={e=>setCloseOnDone(v=>!v)} label="Close after successful finalisation" />
                                </Group>
                                {/* <Text><Anchor onClick={resetFields} size="sm">Reset All Fields</Anchor></Text> (REFRESH THE PAGE)*/}
                            </Group>
                        </Group>,
                })
            }
        />)}



        {/* {q2 && (<div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            margin: '10px',
        }}>
            {loading && (<b>LOADING OVERLAY</b>)}
            <hr />
            <h1>FINALIZATION:STEP2:{zid}:{q2.id}</h1>
            list of options and insurance settings to select for finalise offer
            <i>ProductMenu, Show Price, InsuranceMenu, ExtraFees(?), DiscountType,Amount,effectiveAmount, totalDirectRate, totalRPTRate, Commission, breakdownMemos(int,ext)</i>
            checkboxes to send internal/external memos, update quote link, ticket custom fields, or do nothing
            <hr />

        </div>)} */}
    </>}
    />)
}
export const currencies = ['AUD', 'NZD', 'USD', 'GBP', 'EUR', 'CAD'] as const; 
export type currency = typeof currencies[number]; 

const cache = {} as any
async function getCurrencyRate(from:currency,to:'AUD'|'NZD'):Promise<number|null> {
    if(from==to) return null
    if(!cache.rates) cache.rates = await fetch(`https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${to.toLowerCase()}.json`).then(async res => (await res.json()))
    const factor = cache.rates[to.toLowerCase()][from.toLowerCase()]
    if(factor <= 0 || isNaN(factor)) return null
    return factor
}

export const RPNumberInput = (options) => { // TODO use in calendar.tsx // TODO use theme inherit styles properly
    return <NumberInput
        styles={{
            input: {
                color: '#ced4da',
                backgroundColor: '#242424',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#3a3a3a', // Change color on hover
                },
            },
            rightSection: {
                color: '#ced4da',
            },
            root: {
                width: '100%',
            },
            wrapper: {
                paddingTop: '0.5px', // to match alignment of text input in forms
            },
        }}
        {...options}
    />
}

// Custom components for select dropdowns
interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    value: string,
    label: string,
    description: string,
}
const SelectItem = React.forwardRef<HTMLDivElement, ItemProps>(
    ({ description, label, ...rest }: ItemProps, ref) => (
        <div ref={ref} {...rest}>
            <Group noWrap>
                <div>
                    <Text size="sm">{label}</Text>
                    <Text size="xs" opacity={0.65}>
                        {description}
                    </Text>
                </div>
            </Group>
        </div>
    )
);
const SelectItemRedUnavailable = React.forwardRef<HTMLDivElement,{label:string,available:boolean}>(
    ({ label, available, ...others }, ref) => (
    <div ref={ref} {...others} style={{
        backgroundColor: available ? 'white' : '#f0aaaa'
    }}>
        <Group noWrap>    
        <div>
            <Text>{label}</Text>
        </div>
        </Group>
    </div>
    )
);


// const v2 = ( // working on insurance calculations from commission calculator
//     dailyRate,
//     dailyInsurance,
//     days,
//     extrasNC,
//     extrasC,
//     discount,
//     commissionRate,
//     company,
// ) => {

//     const S2 = 1 // lookup on J which contains only 1
//     const U2 = 1 // lookup on K which contains only 1

//     const dailyIntermediate = (dailyRate * days) * S2
//     const insuranceIntermediate = (dailyInsurance * days) * U2
//     const totalDirectRate = (extrasNC + extrasC) + dailyIntermediate + insuranceIntermediate
//     const totalDiscountedRate = totalDirectRate - discount // what the customer pays
//     const netFactor = {
//         'au.camperman': 0.75,
//         'au.jucy': 0.75,
//         'au.spaceships': 0.75,
//         'au.star': 0.75,
//         'au.apollo': 1, // NET UP
//         'au.tab': 0.78,
//         'au.letsgo': 0.8,
//         'au.mighty': 0.8,
//         'au.cheapa': 1, // NET UP
//         'au.hippie': 1, // NET UP
//         'au.britz': 0.85,
//         'nz.barefoot': 0.75,
//         'nz.spaceships': 0.75,
//         'nz.apollo': 1, // NET UP
//         'nz.tab': 0.78,
//         'nz.jucy': 0.8,
//         'nz.star': 0.8,
//         'nz.mighty': 0.8,
//         'nz.cheapa': 1, // NET UP
//         'nz.britz': 0.85,
//         'nz.maui': 0.9,
//         'nz.biglittle': 0.8,
//     }[company]

//     const is_net_up = false
//     const NET_RATE = is_net_up ? 1 : netFactor * (dailyIntermediate + insuranceIntermediate) // apollo/cheapa/hippi are net up, and have net rate daily multiplier 1, rest are 0.75 or some
//     const extrasCommission = extrasC * commissionRate
//     const commission = dailyIntermediate + insuranceIntermediate - discount - NET_RATE + extrasCommission

//     return {
//         internal: '',
//         external: '',
//         totalDailyRate: 0,
//         totalDirectRate: 0,
//         totalDiscount: 0,
//         total: 0,
//         deposit: 0,
//     }
// }

const generateMemos = (options: {
    localCurrency: 'AUD'|'NZD',
    showCurrency: currency, // to show the discount in another currency
    currencyRate: number, // to show the discount in another currency
    zdid: string, // the ZD ID
    pickup: string,
    start: Date,
    dropoff: string,
    end: Date,
    pax: string, // :number,
    paxChildren: string, // :number,
    // country,
    company: keyof typeof AllOperators,
    camper: string,
    // discountAmount:number, // cents
    discountAmount: number, // dollars or percent
    discountType: 'percent' | 'amount',
    pickupDate: Date,
    link: string,//="http://...",
    days: number,
    dailyRate: number,//=100,
    insurance: number,//=10,
    originalInsuranceRate: number,//=10
    bond: number,//=1000,
    nonCommissionableExtras: number,//= 0,
    commissionableExtras: number,//= 0,
    commRateForCompany: number,
    commRateForCompanyInsurance: number,
    country: string,
    originalRate: number,
    overrideNetRate: null|number, // cents total to set netRate to or null
    manualNetRate: null|number, // cents daily for agent to override netRate, top precedence
    insurancePolicyName: string,
    insuranceMax:number,
    insuranceMin:number,
    paymentDate?:Date,
    paymentProfile: PaymentProfile,
    // overrideDailyRate:null|number, // daily cents
    daily_for_net?: number, // daily cents, used to calculate net from a different daily than is shown
}) => {
    try {
        const {
            localCurrency,
            showCurrency,
            currencyRate,

            zdid,
            pickup,
            start,
            dropoff,
            end,
            pax,
            paxChildren,
            company,
            camper,
            discountAmount = 0,
            discountType,
            pickupDate,
            link,
            days,

            paymentDate = clampDate(
                Date.now()-(0.9*DAY),
                start?.getTime()-(MAX_DAYS*DAY),
                start?.getTime()
            ), // CC2C9
            dailyRate, // cents daily
            originalRate = dailyRate, // cents daily from API
            
            insurance = 0, // cents daily
            originalInsuranceRate = insurance, // cents daily from API

            bond = 0, // cents
            nonCommissionableExtras, // cents
            commissionableExtras, // cents
            commRateForCompany,
            commRateForCompanyInsurance,
            country,

            insurancePolicyName = '',
            insuranceMax,
            insuranceMin,
            overrideNetRate, // cents total
            manualNetRate, // cents total
            // overrideDailyRate=null, // Used by cosmos enrichment to force a daily rate while preserving net calculation

            paymentProfile,
            daily_for_net,
        } = options

        const overrideNetRateDaily = (overrideNetRate??0) / days // DANGER: introduces floating point errors which accumulate

        // const paymentProfile: paymentProfile = payProfiles[`${country}.${company}`]

        const dailyRateCommission = commRateForCompany
        const insuranceRateCommission = commRateForCompanyInsurance ?? commRateForCompany
        const extrasRateCommission = commRateForCompany

        const common = {
            localCurrency,
            showCurrency, // to show the discount in another currency
            currencyRate, // to show the discount in another currency
            days,
            bond,
            link,
            pax,
            paxChildren,
            company,
            camper,
            paymentProfile,
            dropoff,
            pickup,
            paymentDate,
            start,
            end,
            zdid,
        }

        if (paymentProfile.mode == "GROSS_DOWN") {
            // const commission = (days * originalRate * dailyRateCommission) + (commissionableExtras * extrasRateCommission) + (insurance * days * insuranceRateCommission)
            const totalDailyRate = days * dailyRate
            const totalDailyInsurance = insurance * days
            const totalDiscount = (discountType == 'percent') ? totalDailyRate * (discountAmount ?? 0) / 100 : (discountAmount ?? 0) * 100
            const totalExtras = commissionableExtras + nonCommissionableExtras
            const totalDirectRate = totalDailyRate + (insurance * days) + totalExtras

            const calculatedNetRate = (
                (overrideNetRateDaily || ((daily_for_net??dailyRate) * (1 - dailyRateCommission))) +
                (insurance * (1 - insuranceRateCommission)) + 
                (paymentProfile.type == 'FULL_PAYMENT' ? 0 : ((nonCommissionableExtras + (commissionableExtras*(1-extrasRateCommission)))/days))
            ) // cents per day
            const calculatedNetRateTotal = calculatedNetRate*days
            const appliedNetRate = manualNetRate ?? calculatedNetRate
            const netRate = appliedNetRate // calculatedNetRate // overrideNetRateDaily ?? calculatedNetRate // cents per day
            // const commission = totalDailyRate + totalDailyInsurance - totalDiscount - (netRate*days) + (commissionableExtras * extrasRateCommission) + (insurance * days * insuranceRateCommission)
            const total = totalDirectRate - totalDiscount
            // const deposit = total + totalDailyInsurance - (netRate*days) + commissionableExtras * extrasRateCommission // AKA commission?
            const totalRPTRate = totalDirectRate - totalDiscount
            console.log({
                totalRPTRate,
                nonCommissionableExtras,
                commissionableExtras,
                extrasRateCommission,
                netRate,
            })
            const commission = (
                totalRPTRate -
                (netRate*days) - 
                (paymentProfile.type == 'FULL_PAYMENT' ? (nonCommissionableExtras + (commissionableExtras*(1-extrasRateCommission))) : 0)
            )
            console.log({commission, totalRPTRate,netRate,days,paymentProfile,nonCommissionableExtras,commissionableExtras,extrasRateCommission})
            return {
                ...memos({
                    ...common,
                    netRate, // TODO: deprecate
                    netRateTotal: netRate * days, // TODO: avoid division and multiplication, replace netRate
                    RPTComm: commission, //totalDailyRate - totalDiscount - netRate + (insurance * days * insuranceRateCommission) + (commissionableExtras * extrasRateCommission),
                    totalDailyInsurance,
                    totalDailyRate,
                    totalDirectRate,
                    totalRPTRate,
                    totalExtras,
                }),
                netRate, // TODO: deprecate
                netRateTotal: netRate * days, // TODO: avoid division and multiplication, replace netRate
                calculatedNetRateTotal,
                totalDailyRate,
                totalDiscount,
                totalDirectRate,
                total,
                deposit: commission,
                commission,
                paymentProfile,
                calculatedNetRate,
                // if type=='DEPOSIT', payoff_amount is the amount charged in stripe
                payoff_amount: (paymentProfile.type == 'FULL_PAYMENT' ? (netRate * days) : commission),
                // payoff_amount: netRate * days,
                // payoff_amount: (paymentProfile.type == 'FULL_PAYMENT' ? (netRate * days) : commission),
                // payoff_amount: splitPayment ? (paymentProfile.type == 'FULL_PAYMENT' ? (netRate * days) : commission) : 0,
            }
        }

        const comm = (total) => (overrideNetRate) ? total - overrideNetRate : null

        if (paymentProfile.mode == "NET_UP") { // Only for THL
            // const commission = (days * originalRate * dailyRateCommission) + (commissionableExtras * extrasRateCommission) + (insurance * days * insuranceRateCommission)
            const totalDailyRate = 100 * Math.round(days * dailyRate / 100)
            const totalDailyInsuranceMax = (insurancePolicyName.toUpperCase().includes('VALUE PACK') ? Math.floor(insurance/100)*100 : insurance) * days
            const totalDailyInsuranceMin = insuranceMax ? Math.min(totalDailyInsuranceMax,insuranceMax) : totalDailyInsuranceMax
            const totalDailyInsurance = insuranceMin ? Math.max(totalDailyInsuranceMin,insuranceMin) : totalDailyInsuranceMin
            const totalDiscount = (discountType == 'percent') ? totalDailyRate * (discountAmount ?? 0) / 100 : (discountAmount ?? 0) * 100
            const totalExtras = commissionableExtras + nonCommissionableExtras

            // NOTE: NET_UP operators rates are provided to the frontend with *= 1.25 multiplier (or 1.18 where comm is 0.18)
            // commRateForCompany must match the multiplier used (excluding the 0.95 factor) on the server for this to work:
            const multiply2Factor = 0.95 // An extra 5% commission factor used in NET_UP operators (only for vehicle, not insurance)
            const expectedMultiplier = 1+commRateForCompany
            const expectedMultiplierInsurance = 1.25 // commRateForCompanyInsurance
            

            // NET calculations:
            // const calculatedNetRate = Math.round(
            //     (overrideNetRateDaily || ((daily_for_net??originalRate)*multiply2Factor/expectedMultiplier)) +
            //     (originalInsuranceRate/expectedMultiplierInsurance)
            //     // + (paymentProfile.type == 'FULL_PAYMENT' ? 0 : ((nonCommissionableExtras + (commissionableExtras*(1-extrasRateCommission)))/days))
            // ) //- commission // *(1-dailyRateCommission)
            // const appliedNetRate = manualNetRate ?? calculatedNetRate
            // const netRate = appliedNetRate // calculatedNetRate // overrideNetRateDaily ?? calculatedNetRate // NOTE: This is daily
            const netRateTotalProduct = overrideNetRate ?? ((overrideNetRateDaily || ((daily_for_net??originalRate)*multiply2Factor/expectedMultiplier)) * days)
            const netRateTotalInsuranceMax = (originalInsuranceRate/expectedMultiplierInsurance)*days
            const netRateTotalInsuranceMin = insuranceMax ? Math.min(netRateTotalInsuranceMax,insuranceMax/expectedMultiplierInsurance) : netRateTotalInsuranceMax
            const netRateTotalInsurance = insuranceMin ? Math.max(netRateTotalInsuranceMin,insuranceMin/expectedMultiplierInsurance) : netRateTotalInsuranceMin
            console.log(netRateTotalInsuranceMax,insuranceMax,netRateTotalInsurance)
            const netRateTotalOther = 0 // nonCommissionableExtras

            const netRateTotal = manualNetRate ? Math.round(manualNetRate * days) : Math.round(netRateTotalProduct + netRateTotalInsurance + netRateTotalOther)
            const calculatedNetRate = Math.round((netRateTotalProduct + netRateTotalInsurance + netRateTotalOther)/days)
            const calculatedNetRateTotal = Math.round(netRateTotalProduct + netRateTotalInsurance + netRateTotalOther)
            const appliedNetRateTotal = manualNetRate ? manualNetRate * days : netRateTotal
            const netRate = appliedNetRateTotal/days

            console.log({
                totalDailyRate,
                totalDailyInsurance,
                totalDiscount,
                totalExtras,
                originalRate,
                multiply2Factor,
                expectedMultiplier,
                originalInsuranceRate,
                expectedMultiplierInsurance,
            })
            // const originalRateGross = originalRate / (1-commRateForCompany)
            // const originalInsuranceRateGross = originalInsuranceRate / (1-commRateForCompanyInsurance)
            // const commissionForDaily = originalRateGross * days * commRateForCompany
            // const commissionForInsurance = originalInsuranceRateGross * days * commRateForCompanyInsurance
            const commissionForExtras = commissionableExtras * extrasRateCommission
            // const commission = commissionForDaily + commissionForInsurance + commissionForExtras - totalDiscount


            // // const totalDirectRate = (
            // //     (originalRate / (1-commRateForCompany))*days +
            // //     (originalInsuranceRate / (1-commRateForCompanyInsurance))*days +
            // //     (commissionableExtras / (1-extrasRateCommission)) +
            // //     nonCommissionableExtras
            // // )
            const totalDirectRate = (
                totalDailyRate + // commissionForDaily +
                totalDailyInsurance + // commissionForInsurance +
                commissionableExtras + commissionForExtras +
                nonCommissionableExtras
            )

            // // const totalDirectRate = totalDailyRate + (insurance * days) + totalExtras
            
            // // const commission = totalDirectRate - netRate - totalDiscount
            const totalRPTRate = totalDirectRate - totalDiscount 
            const total = totalRPTRate
            const commission = //comm(totalDirectRate) ?? 
                (totalRPTRate - (netRateTotal) - totalExtras)
                // (totalRPTRate - (netRateTotal)) // In order for NET to match the number at the bottom on Motek, which includes 1WF (hence all NCFees), we cannot subtract extras here, since it is included in the NET we subtract 
            // console.log({commission, totalRPTRate,netRate,days,totalExtras})

            // // const commission = totalRPTRate - (
            // //     nonCommissionableExtras + 
            // //     (commissionableExtras*(1-extrasRateCommission)) + 
            // //     (totalDailyRate*(1-commRateForCompany)) +
            // //     (totalDailyInsurance*(1-commRateForCompanyInsurance))
            // // )

            console.log({
                totalDailyRate,
                totalDailyInsurance,
                totalDiscount,
                totalExtras,
                totalDirectRate,
                totalRPTRate,
                commission,
                calculatedNetRate,
                netRate, // TODO: deprecate
                netRateTotal, // TODO: avoid division and multiplication, replace netRate
            })
            return {
                ...memos({
                    ...common,
                    netRate, // TODO: deprecate
                    netRateTotal, // TODO: avoid division and multiplication, replace netRate
                    RPTComm: commission, //totalDailyRate - totalDiscount - netRate + (insurance * days * insuranceRateCommission) + (commissionableExtras * extrasRateCommission),
                    totalDailyInsurance,
                    totalDailyRate,
                    totalDirectRate,
                    totalRPTRate, // totalExtras + totalDailyRate - totalDiscount + totalDailyInsurance
                    totalExtras,
                }),
                netRate, // TODO: deprecate
                netRateTotal, // TODO: avoid division and multiplication, replace netRate
                calculatedNetRateTotal,
                totalDailyRate,
                totalDiscount,
                totalDirectRate,
                total,
                deposit: commission,
                commission,
                paymentProfile,
                calculatedNetRate,
                // if type=='DEPOSIT', payoff_amount is the amount charged in stripe
                payoff_amount: (paymentProfile.type == 'FULL_PAYMENT' ? (netRate * days) : commission), // NET_UP is almost always FULL_PAYMENT
                // payoff_amount: (netRate * days),
            }
        }
        throw `Error: Unknown payment profile mode for operator ${country}.${company}`
    } catch (get_memo_error) {
        console.warn({ get_memo_error })
        return {
            internal: `Error: ${get_memo_error}`,
            external: '',
            totalDailyRate: 0,
            totalDirectRate: 0,
            totalDiscount: 0,
            total: 0,
            deposit: 0,
            commission: 0,
            paymentProfile: null as any,
            netRate: 0,
            calculatedNetRate: 0,
            netRateTotal: 0,
            calculatedNetRateTotal: 0,
            payoff_amount: 0,
        }
    }
    // // TODO discounting logic

    // // const country = "Australia" // CC2B3 // AGENT INPUT
    // // const company = "Spaceships" // CC2C3 // AGENT INPUT // FORMAT: Spaceships Au
    // // const camper = "Beta 2S Au" // CC2D3 // AGENT INPUT // FORMAT: Alpha Au
    // // const days = 10 // CC2F3 // AGENT INPUT
    // // const dailyRate = 100 // CC2H3 // "gross" // AGENT INPUT
    // // const insurance = 30 // CC2K3 // AGENT INPUT
    // // const bond = 0 // CC2L3 // AGENT INPUT
    // // const nonCommissionableExtras = 0 // CC2M6 // AGENT INPUT
    // // const commissionableExtras = 0 // CC2M9 // AGENT INPUT
    // // const discountType = '$' // CC2C17 // AGENT INPUT
    // // const discountProvided = 0 // CC2C18 // AGENT INPUT
    // // const pickupDate = new Date() // CC2C7 // AGENT INPUT

    // // const FF2N2 = "Gross" || "Net Cheapa NZ" || "Net Apollo Oz" || "..."
    // const FF2S2 = 1 // paymentProfile.mode == 'GROSS_DOWN' ? 1 : 1 - commRateForCompany // 1 /* lookup F2J2 where FF2H2 == FF2N2 */
    // const totalDailyRate = days * dailyRate * FF2S2 // CC2I3 // The "direct rate" to show

    // // const link = "http://.." // lookup F2AS=CC2D3 // check data.ts
    // const F2U2 = 1 /* lookup F2K2 where F2B2 == F2T3 */
    // const totalDailyInsurance = insurance * F2U2 * days // CC2M3

    // // TODO: insurance commission rate

    // const totalDailyAndInsurance = totalDailyRate + totalDailyInsurance // CC2C11 // substitute for inline, useless var
    // const totalExtras = nonCommissionableExtras + commissionableExtras // CC2F11
    // const totalDirectRate = totalDailyAndInsurance + totalExtras // CC2F15

    // // const discountAmount = 0 /* lookup (F2AN2=CC2I3*0.01) where F2AM2 == discountProvided */ // F2AP2 // CC2C19 // AKA "0.01 * totalDailyRate when 1%"
    // const totalDiscount = (discountType == 'percent') ? totalDailyRate * (discountAmount ?? 0) / 100 : (discountAmount ?? 0) * 100
    // const rptDailyAndInsurance = totalDailyRate - totalDiscount + totalDailyInsurance // CC2C23 // substitute for inline, useless var
    // // const totalExtras = nonCommissionableExtras + commissionableExtras // CC2F23 // duplicate
    // const totalRPTRate = rptDailyAndInsurance + totalExtras // CC2F27

    // const netRateAppliedDaily = paymentProfile.mode == 'GROSS_DOWN' ? 1 - commRateForCompany : 1 // 0.75 // F2I2 where F2D2 == company // F2L2 // AKA "the net rate for this company"
    // const netRateDaily = dailyRate * days * netRateAppliedDaily // F2O2
    // const netRateInsurance = insurance * days * netRateAppliedDaily // F2P2
    // const netRate = netRateDaily + netRateInsurance // [cheapa,apollo,hippieAu].includes(company) ? "" : netRateDaily + netRateInsurance // CC2M20
    // // const blank = 0 // CC2M21 // mistake? used by CC2M27 and CC2M22

    // // const commRateForCompany = 0.25 // lookup F2V2 where F2D2==CC2C3 // F2AF2 // CC2E3
    // const extrasComm = commissionableExtras * commRateForCompany // F2R2
    // const RPTComm = rptDailyAndInsurance - netRate + extrasComm // CC2M27
    // // const paymentDate = pickupDate.getTime() - (65 * DAY) // CC2C9
    // // const netRate = CC2M20 // CC2M22 // duplicate

    // console.debug({
    //     totalDailyInsurance,
    //     totalDailyAndInsurance,
    //     totalExtras,
    //     totalDirectRate,
    //     totalDiscount,
    //     rptDailyAndInsurance,
    //     totalRPTRate,
    //     netRateAppliedDaily,
    //     netRateDaily,
    //     netRateInsurance,
    //     netRate,
    //     extrasComm,
    //     RPTComm,
    //     paymentDate,
    // })
}
const memos = ({
    localCurrency,
    showCurrency,
    currencyRate,
    bond,
    camper,
    company,
    days,
    dropoff,
    link,
    netRate, // TODO: deprecate
    netRateTotal, // TODO: prefer this to avoid floating point errors
    pax,
    paxChildren,
    paymentDate,
    paymentProfile,
    pickup,
    RPTComm,
    totalDailyInsurance,
    totalDailyRate,
    totalDirectRate,
    totalRPTRate,
    totalExtras,
    start,
    end,
    zdid,
}) => {
    try {
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ]

        const dMMMMyyyy = (d: number) => { // 1 October, 2024
            const D = new Date(d)
            const day = D.getDate();
            const month = months[D.getMonth()]
            const year = D.getFullYear()
            return `${day} ${month}, ${year}`
        }
        const MMMMdyyyy = (d: number) => { // October 1, 2024
            const D = new Date(d)
            const day = D.getDate();
            const month = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ][D.getMonth()]
            const year = D.getFullYear()
            return `${day} ${month}, ${year}`
        }

        const paymentType: PaymentType = paymentProfile?.type ?? "DEPOSIT" /* lookup F2E2 where F2D2 == company */ // F2F2 // CC2C5 // AKA "paymentType for this company, deposit or full?"
        const alreadyDue = paymentDate <= Date.now() || (paymentDate?.getTime()+(MIN_DAYS*DAY) > start?.getTime()) // CC2D9 // AKA "if not depositing, is the MAX_DAYSPrior payment date already passed?"
        
        const nice = location => All_States.find(({key})=>key==location)?.nice ?? location
        const optionalCurrency = (amount:number, local:currency=localCurrency, rate:number|null=currencyRate, target:currency=showCurrency, rounding=0) => rate ? 
            `$${(amount/100).toFixed(rounding)} ${local} (${(rate*amount/100).toFixed(rounding)} ${target})` : 
            `$${(amount/100).toFixed(rounding)} ${local}`

        const paymentDueDays = daysBetween(paymentDate,start)
        const external = [
            `${[nice(pickup), MMMMdyyyy(start.getTime())].join(' - ')}`,
            `${[nice(dropoff), MMMMdyyyy(end.getTime())].join(' - ')}`,
            `Here is a reminder of the campervan spec link:`,
            link?.length? link : '*** ENTER HERE! ***',
            `The direct daily rate is $${(totalDailyRate / days / 100).toFixed(2)} plus $${(totalDailyInsurance / days / 100).toFixed(0)} per day for the excess reduction which reduces your excess to $${(bond / 100).toFixed(0)}. Plus the extras of $${(totalExtras / 100).toFixed(0)}`,
            `The total direct cost over the ${days} days = $${(totalDirectRate / 100).toFixed(2)}`,
            `*The total discounted rate = ${optionalCurrency(totalRPTRate)}*`,
            `This saves you a total of $${((totalDirectRate - totalRPTRate) / 100).toFixed(2)}`,
            `There is only 1 of these vans left at this discounted rate.`,
            (paymentType == 'DEPOSIT') ? `To reserve this camper the company requires a deposit of ${optionalCurrency(RPTComm)} with the remaining balance to be paid directly to the camper company as per their terms.`
                : alreadyDue ? `As your pick up is within the next ${MAX_DAYS} days the camper company requires the balance in full in order to reserve the campervan, the amount payable today is: $${((totalRPTRate-totalExtras) / 100).toFixed(2)}`
                    : `To reserve this camper the company requires a deposit of ${optionalCurrency(RPTComm)} with the remaining balance due ${paymentDueDays} days before your pick-up date on ${dMMMMyyyy(paymentDate)}.`,
            `As a reminder - if any disruptions occur then we can simply move your booking free of charge, meaning there are no admin fees from our side, but the rates and availability are set by the camper company.`,
            `Would you like me to reserve this last discounted campervan for you?`,
        ].join('\n\n')

        // NOTE: netRate is daily

        const internal = [
            `Reference: ${zdid}`,
            `Pick-up: ${[nice(pickup), MMMMdyyyy(start.getTime())].join(' - ')}`,
            `Drop-off: ${[nice(dropoff), MMMMdyyyy(end.getTime())].join(' - ')}`,
            `Days: ${days}`,
            `Adults: ${pax}`,
            `Children (Under 8): ${paxChildren||0}`,
            `Company: ${AllOperators[company] ?? company}`,
            `Model: ${camper}`,
            `Excess Reduction (per day): $${((totalDailyInsurance / days) / 100).toFixed(2)}`,
            `Bond Amount: $${(bond / 100).toFixed(2)}`,
            ...((paymentType == 'DEPOSIT') ? [
                `Deposit Amount: $${(RPTComm / 100).toFixed(2)}`,
                `Remaining Balance due: $${((netRate*days) / 100).toFixed(2)}`,
            ] : alreadyDue ? [ // <MAX_DAYS days:
                `Total Payable to Reserve: $${((totalRPTRate-totalExtras) / 100).toFixed(2)}`,
                `Extras Payable on Arrival: $${(totalExtras / 100).toFixed(2)}`,
            ] : [ // >MAX_DAYS days:
                `Deposit Amount: $${(RPTComm / 100).toFixed(2)}`,
                `Remaining Balance: ${dMMMMyyyy(paymentDate)} (due ${paymentDueDays} days before pickup): $${((netRate * days) / 100).toFixed(2)}`,
                `Total Payable to Reserve: $${((totalRPTRate-totalExtras) / 100).toFixed(2)}`,
                // `Total Payable to RatPack: $${((RPTComm + netRate*days-totalExtras) / 100).toFixed(2)}`,
                `Extras Payable on Arrival: $${(totalExtras / 100).toFixed(2)}`,
            ]),
            `TOTAL: $${(totalRPTRate / 100).toFixed(2)}`,
            `-----------------------------------------`,
            `Commission: $${(RPTComm / 100).toFixed(2)}`,
        ].join('\n\n')

        return {
            internal,
            external,
        }
    } catch (memo_error) {
        console.warn({ memo_error })
        return {
            internal: `Error: ${memo_error}`,
            external: '',
            totalDailyRate: 0,
            totalDirectRate: 0,
            totalDiscount: 0,
            total: 0,
            deposit: 0,
        }
    }
}

// For rendering numbers with a label, and turning red when a rule like <=0 is met
const RedNumber = ({
    prefix = '$',
    rule = v => v <= 0,
    n = 0,
    label = "",
}) => {
    const N = typeof n == 'number' ? n.toFixed(2) : n
    return (<Text size="xs">{label}<Text size="md" color={rule(n) ? 'red' : 'black'}>{prefix}{N}</Text></Text>)
}

// For rendering generated text
const NotePaper = ({
    placeholder = "Must include message",
    label,
    useValue,
    disabled = false,
}) => {
    return <>
        {/* <Paper shadow="xs" radius="xs" p="md" style={{
            maxWidth: '100%',
            overflow:'scroll',
            maxHeight: '250px',
            width: '100%',
        }}> */}
        <Textarea
            size="sm"
            style={{
                overflow: 'scroll',
                maxHeight: '300px',
                width: '100%',
                // fontSize: '12px',
                // minWidth: '1600px',
            }}
            styles={{
                input: {
                    height: '250px',
                    lineHeight: 0.9,
                }
            }}
            placeholder={placeholder}
            label={label}
            {...useValue}
            disabled={disabled}
        ></Textarea>
        {/* </Paper> */}
    </>
}
const daysBetween = (a:Date,b:Date) => Math.abs(Math.round((a?.getTime() - b?.getTime()) / DAY))
